import { render } from "./RolList.vue?vue&type=template&id=43695ad1"
import script from "./RolList.vue?vue&type=script&lang=js"
export * from "./RolList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__